import { render } from "./DefaultCarousel.vue?vue&type=template&id=a7c85e18&scoped=true"
const script = {}

import "./DefaultCarousel.vue?vue&type=style&index=0&id=a7c85e18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7c85e18"]])

export default __exports__